import ResetUsersPassword from "../../../pages/lodge/resetPassword/ResetUsersPassword";

export default function ResetUsersPasswordView() {
  return <ResetUsersPassword />
}